import { formatNumber } from '@angular/common';
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { EnergyUnits, EnergyUnitService } from '../services/energy-unit.service';

// Shows a consumption (given in MWh) or a price (given in €/MWh) in the unit the user chose, formatted for that unit.
// {{ value | energy:'consumption':'1.0-3' }} - the digits are the ones to use when the unit is MWh.
// Impure so it follows the unit setting; the work is a multiplication and a format.
@Pipe({ name: 'energy', pure: false })
export class EnergyPipe implements PipeTransform {
    constructor(private readonly _energyUnitService: EnergyUnitService, @Inject(LOCALE_ID) private readonly _locale: string) {}

    transform(value: number | null | undefined, type: 'consumption' | 'price', mwhDigits: string = type == 'price' ? '1.2-2' : '1.0-3'): string {
        if (value == null || isNaN(value)) {
            return '';
        }

        const unit = this._energyUnitService.getUnit(type);
        const converted = type == 'consumption' ? EnergyUnits.convertConsumption(value, unit) : EnergyUnits.convertPrice(value, unit);

        return formatNumber(converted, this._locale, EnergyUnits.getDigits(type, unit, mwhDigits));
    }
}

// Shows a consumption stored in kWh (opportunities) in the unit the user chose.
// {{ value | kwhEnergy }} - the digits are the ones to use when the unit is MWh.
@Pipe({ name: 'kwhEnergy', pure: false })
export class KwhEnergyPipe implements PipeTransform {
    constructor(private readonly _energyUnitService: EnergyUnitService, @Inject(LOCALE_ID) private readonly _locale: string) {}

    transform(value: number | null | undefined, mwhDigits: string = '1.0-3'): string {
        if (value == null || isNaN(value)) {
            return '';
        }

        const unit = this._energyUnitService.consumptionUnit;

        return formatNumber(EnergyUnits.kwhToDisplay(value, unit), this._locale, EnergyUnits.getDigits('consumption', unit, mwhDigits));
    }
}

// The unit label: 'MWh' or 'kWh' for consumptions, '€/MWh' or '€/kWh' for prices.
// {{ 'consumption' | energyUnit }}
@Pipe({ name: 'energyUnit', pure: false })
export class EnergyUnitPipe implements PipeTransform {
    constructor(private readonly _energyUnitService: EnergyUnitService) {}

    transform(type: 'consumption' | 'price'): string {
        return EnergyUnits.getUnitLabel(type, this._energyUnitService.getUnit(type));
    }
}
